
import React, { useContext, useEffect, useState } from "react";
import { FormElement, FormLabel, FormSubLabel, FormInput, FormSelector, FormToggle } from "../StyledElements";
import { Dialog } from "../Dialog";
import { saveDataItem } from "../../services/data";
import { Icon } from "@iconify/react";
import swal from "sweetalert2";
import { AppContext } from "../../contexts/AppContext";

const MediaTypeFields = ({ dataItem, onDataItemUpdate = () => { } }) => {
  const [filePreview, setFilePreview] = useState(null);

  switch (dataItem.sourceType) {
    case "file-upload":
      return (
        <FormElement>
          <FormLabel label="Upload File" />
          <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "10px", height: "auto", position: "relative" }}>
            {
              filePreview && (
                <div style={{
                  width: "100%",
                  position: "relative",
                  flexGrow: 1,
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                >
                  {
                    dataItem.sourceConfig.fileType?.startsWith("image/") ? (
                      <img src={filePreview} alt="Uploaded file preview" style={{ maxWidth: "100%", maxHeight: "200px", borderRadius: "8px" }} />
                    ) : dataItem.sourceConfig.fileType?.startsWith("video/") ? (
                      <video controls style={{ maxWidth: "100%", maxHeight: "200px", borderRadius: "8px" }}>
                        <source src={filePreview} type={dataItem.sourceConfig.fileType} />
                        Your browser does not support the video tag.
                      </video>
                    ) :
                      dataItem.sourceConfig.fileType?.startsWith("audio/") ? (
                        <audio controls style={{ width: "100%" }}>
                          <source src={filePreview} type={dataItem.sourceConfig.fileType} />
                            Your browser does not support the audio element.
                        </audio>
                      ) :
                        (
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "#999", fontStyle: "italic" }}>
                            <Icon icon="mdi:file" style={{ fontSize: "48px", marginBottom: "8px" }} />
                            <div>{dataItem.sourceConfig.fileName || "Uploaded file"}</div>
                          </div>
                        )
                  }
                </div>)
            }
            <div style={{
              width: "100%",
              border: "2px dashed #ccc",
              position: "relative",
              flexGrow: 1,
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#999",
              fontStyle: "italic",
              minHeight: "100px",
            }}
            >
              Drag & Drop File Here
          <input type="file" style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                top: 0,
                left: 0,
                opacity: 0,
                cursor: "pointer",
              }}
                onChange={(e) => {
                  // Handle file selection logic here
                  const file = e.target.files[0];
                  console.log("Selected file: ", file);
                  if (file) {
                    setFilePreview((prev) => {
                      if (prev) URL.revokeObjectURL(prev);
                      return URL.createObjectURL(file);
                    })

                    onDataItemUpdate({ ...dataItem, file: file, sourceConfig: { fileName: file.name, fileType: file.type } });

                    /* Show the video, even if it's large - we can handle the upload separately */
                    /*
                    const reader = new FileReader();
                    reader.onloadend = () => {
                      setUpdatedVideo(reader.result);
                    };
                    reader.readAsDataURL(file);
                    */

                    console.log("!!! FILE: ", file);

                    /*setUpdatedEvent({
                      ...updatedEvent,
                      video_file: file,
                      video_file_name: file.name,
                    });*/
                  };
                }}
              />
            </div>
          </div>
        </FormElement>
      );
    case "url":
      return (
        <>
          <FormElement>
            <FormLabel label="Data URL" />
            <FormInput placeholder="Enter the URL for this data"
              value={dataItem.sourceConfig?.url || ""}
              onChange={(e) => {
                onDataItemUpdate({ ...dataItem, sourceConfig: { url: e.target.value } });
              }}
            />
          </FormElement>
          <FormElement>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "8px" }}>
              <FormToggle
                checked={dataItem.sourceConfig?.followLinks ?? false}
                onChange={(e) => {
                  onDataItemUpdate({ ...dataItem, sourceConfig: { ...dataItem.sourceConfig, followLinks: e.target.checked } });
                }}
              />
              <FormLabel style={{ marginBottom: 0 }} label="Follow Links" />
            </div>
          </FormElement>
          {
            dataItem.sourceConfig?.followLinks && (
              <>
                <FormElement>
                  <FormLabel label="Link Pattern (optional)" />
                  <div>Regex pattern: {dataItem.sourceConfig.linkPattern}</div>
                  <FormInput placeholder="Enter a regex pattern to match which links to follow (optional)"
                    value={dataItem.sourceConfig?.linkPattern || ""}
                    onChange={(e) => {
                      onDataItemUpdate({ ...dataItem, sourceConfig: { ...dataItem.sourceConfig, linkPattern: e.target.value } });
                    }}
                  />
                </FormElement>
                <FormElement>
                  <FormLabel label="Link Depth" />
                  <FormInput type="number" min={1} max={10} placeholder="Enter how many levels of links to follow"
                    value={dataItem.sourceConfig?.linkDepth || 1}
                    onChange={(e) => {
                      onDataItemUpdate({ ...dataItem, sourceConfig: { ...dataItem.sourceConfig, linkDepth: parseInt(e.target.value) } });
                    }}
                  />
                </FormElement>
              </>
            )

          }
          <FormElement>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "8px" }}>
              <FormToggle
                checked={dataItem.sourceConfig?.scheduled ?? false}
                onChange={(e) => {
                  onDataItemUpdate({ ...dataItem, sourceConfig: { ...dataItem.sourceConfig, scheduled: e.target.checked } });
                }}
              />
              <FormLabel style={{ marginBottom: 0 }} label="Scheduled" />
            </div>
          </FormElement>
          {
            dataItem.sourceConfig?.scheduled && (
              <FormElement>
                <FormLabel label="Frequency" />
                <FormSelector
                  value={dataItem.sourceConfig?.frequency || "daily"}
                  options={[
                    { label: "Hourly", value: "hourly" },
                    { label: "Daily", value: "daily" },
                    { label: "Weekly", value: "weekly" },
                    { label: "Monthly", value: "monthly" },
                  ]} placeholder="Select how often to fetch this data"
                  onChange={(e) => {
                    onDataItemUpdate({ ...dataItem, sourceConfig: { ...dataItem.sourceConfig, frequency: e.target.value } });
                  }}
                />
              </FormElement>
            )
          }
        </>
      );
    case "text":
      return (
        <FormElement>
          <FormLabel label="Data Text" />
          <FormInput as="textarea" rows={5} placeholder="Enter the text for this data" style={{ resize: "vertical" }}
            value={dataItem.sourceConfig?.text || ""}
            onChange={(e) => {
              onDataItemUpdate({ ...dataItem, sourceConfig: { text: e.target.value } });
            }}
          />
        </FormElement>
      );
    default:
      return null;
  }
}

export const NewDataDialog = ({ show, onClose, onSave = () => { } }) => {
  const { setMedia, media, selectedClient } = useContext(AppContext);
  const [saveText, setSaveText] = useState("Save");
  const [dataItem, setDataItem] = useState({
    name: "",
    sourceType: "file-upload",
    sourceConfig: {
      file: null,
      url: "",
      followLinks: false,
      linkPattern: "",
      linkDepth: 1,
      scheduled: false,
      frequency: "daily",
      text: "",
    },
  });

  useEffect(() => {
    setDataItem({
      name: "",
      sourceType: "file-upload",
      sourceConfig: {
        file: null,
        url: "",
        followLinks: false,
        linkPattern: "",
        linkDepth: 1,
        scheduled: false,
        frequency: "daily",
        text: "",
      },
    });

  }, [show]);

  const saveData = async () => {
    // Implement your save logic here, e.g., send data to backend or update state
    setSaveText("Saving...");
    const results = await saveDataItem(selectedClient.id, dataItem);
    setSaveText("Save");
    if (!results.success) {
      swal.fire({
        title: "Error",
        text: results.message || "Failed to save data item.",
        icon: "error",
      });
    } else {

      const dataItem = results.data_item;
      const newMedia = [dataItem, ...(media || [])];
      setMedia(newMedia);

      // Allow the caller to do something with the new item
      onSave(dataItem);

      swal.fire({
        title: "Success",
        text: "Data item saved successfully.",
        icon: "success",
      }).then(() => {
        onClose();
      });
    }


  };

  return (
    <Dialog
      title="Create Data Item"
      subtitle={""}
      show={show}
      onClose={onClose}
      onOK={saveData}
      okText={saveText}
      closeText="Close"
      style={{ width: "500px" }}
    >
      <FormElement>
        <FormLabel label="Data Name" />
        <FormInput placeholder="Enter a name for this data"
          value={dataItem.name}
          onChange={(e) => {
            setDataItem({ ...dataItem, name: e.target.value });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Data Description" />
        <FormSubLabel label="Optional parameter to be used for document selection in some workflows" />
        <FormInput as="textarea" rows={3} placeholder="Enter a description for this data (optional)" style={{ resize: "vertical" }}
          value={dataItem.description || ""}
          onChange={(e) => {
            setDataItem({ ...dataItem, description: e.target.value });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Data Source" />
        <FormSelector
          value={dataItem?.sourceType ?? "file-upload"}
          options={[
            { label: "File Upload", value: "file-upload" },
            { label: "URL", value: "url" },
            { label: "Text", value: "text" },
          ]} placeholder="Select a data source type"
          onChange={(e) => {
            console.log("!!! SELECTED SOURCE TYPE: ", e.target.value);
            setDataItem({ ...dataItem, sourceType: e.target.value });
          }}
        />
      </FormElement>
      <MediaTypeFields dataItem={dataItem} onDataItemUpdate={(dataItem) => {
        console.log("!!! UPDATED DATA ITEM: ", dataItem);
        setDataItem(dataItem);
      }} />
    </Dialog>
  );
};

export default NewDataDialog;
